import React from 'react'
import './KnowledgeSearch.css'
import Input from '../../../components/Input'
import { SearchIcon } from '../../../conf/images'

interface KnowledgeSearchProps {
    onChange?: (value: string) => void
    onBlur?: () => void
    value?: string
    onFocus?: () => void
}
const KnowledgeSearch: React.FC<KnowledgeSearchProps> = (props) => {
    const {
        onChange = () => undefined,
        value = '',
        onBlur = () => undefined,
        onFocus = () => undefined,
    } = props

    return (
        <div className='knowledge-search'>
            <p className='knowledge-search__title'>请搜索并选择已有知识点</p>
            <Input
                className='knowledge-search__input'
                placeholder='搜索知识'
                multiple={false}
                value={value}
                onBlur={onBlur}
                onFocus={onFocus}
                onChange={onChange}
                prefix={
                    <img
                        className='search-icon'
                        src={SearchIcon}
                        alt='search'
                    />
                }
            />
        </div>
    )
}

export default KnowledgeSearch
